import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import api from "@/api";
import ice_fonts from "@/utils/fonts";
export default {
  name: "CommonHtmlPreviewView",
  components: {},
  props: {
    htmlVersion: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      htmlId: this.$route.params.htmlId,
      footerId: this.$route.query.footer,
      pageId: this.$route.query.page,
      title: null,
      html: null,
      footer: null,
      page: null,
      siteName: null
    };
  },
  methods: {
    loadFonts() {
      ice_fonts.getCustomFonts().forEach(ft => {
        // 创建一个新的样式标签
        const style = document.createElement('style');
        style.type = 'text/css';
        // 定义 @font-face 规则
        const fontFace = `
        @font-face {
          font-family: ${ft.font};
          src: url('${ft.url}') format('woff2');
          font-weight: normal;
          font-style: normal;
        }
      `;
        // 将规则插入到样式标签中
        style.appendChild(document.createTextNode(fontFace));
        // 将样式标签添加到 head 中
        document.head.appendChild(style);
      });
    },
    queryStyleAndSet() {
      api.querySiteStyle(this.htmlId).then(ret => {
        this.siteName = ret.siteName;
        this.$refs.renderArea.style.setProperty('--table-deep-bg-color', ret.deep);
        this.$refs.renderArea.style.setProperty('--table-light-bg-color', ret.light);
      });
    },
    replaceHtml(html) {
      return html.replaceAll('$DOMAIN$', `<a href="#" class="domain-link">${this.siteName ? this.siteName : '站点名称'}</a>`);
    },
    addSubTitleClassToSpans(divId) {
      // 获取指定的 div 元素
      const div = document.getElementById(divId);
      if (div) {
        // 查找该 div 下所有的 span
        const spans = div.querySelectorAll('span');
        spans.forEach(span => {
          // 获取每个 span 的样式
          const computedStyle = window.getComputedStyle(span);
          // 检查 font-size 是否为 16px 且包含 strong 标签
          if (computedStyle.fontSize === '16px' && span.querySelector('strong')) {
            // 添加 'sub-title' 类
            span.classList.add('sub-title');
          }
        });
      }
    },
    init() {
      let thiz = this;
      this.queryStyleAndSet();
      api.getEnumValueById(this.htmlId).then(ret => {
        this.title = ret.label;
        this.extra = ret.extra;
        if (this.htmlVersion) {
          console.log('读取历史版本:', this.htmlVersion);
          api.get(this.htmlVersion, {
            ice_plain: true
          }).then(ctn => {
            thiz.html = this.replaceHtml(ctn);
            setTimeout(() => {
              thiz.addSubTitleClassToSpans('content-render');
            }, 200);
          });
        } else if (ret.extra.html) {
          api.get(ret.extra.html, {
            ice_plain: true
          }).then(ctn => {
            thiz.html = this.replaceHtml(ctn);
            setTimeout(() => {
              thiz.addSubTitleClassToSpans('content-render');
            }, 200);
          });
        } else {
          thiz.html = '此页面无数据';
        }
      });
      if (this.footerId != null) {
        const thiz = this;
        api.getEnumValueById(this.footerId).then(ret => {
          if (ret.extra.html) {
            api.get(ret.extra.html, {
              ice_plain: true
            }).then(ctn => {
              thiz.footer = this.replaceHtml(ctn);
              setTimeout(() => {
                thiz.addSubTitleClassToSpans('foot-render');
              }, 200);
            });
          }
        });
      }
      if (this.pageId != null) {
        api.getSitePageById(this.pageId).then(ret => {
          this.page = ret;
        });
      }
      this.loadFonts();
    }
  },
  mounted() {
    this.init();
  }
};